module.exports = __webpack_public_path__ + "img/529.70b2d419.jpg";